// src/modules/Onboarding/runtime/external/featureFlags.ts
//
// Manifest-configurable feature flags — resolved when OnboardingBuilder asks
// via its `feature-flag-callback` prop. The callback itself (resolveFeatureFlag)
// lives in useOnboardingBuilderState.ts; this file only declares flags whose
// value is derived from ctx (not from ABSmartly).
//
// Contract: `defineFeatureFlag({ description, type, resolve })` where
// `resolve: (ctx) => boolean | number`. The `type` tag constrains the
// `resolve` return type at compile time via `FlagTagFor<T>`.
//
// Adding a flag: append one entry below, run `npm run generate-runtime-manifest`.

import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

import { defineFeatureFlag, type FeatureFlagsMap } from '../types'

export const featureFlags = {
	hide_age_selection_screen: defineFeatureFlag({
		description: 'True when `lptype` is `age_selection*` (age screen already shown on the landing).',
		type: 'boolean',
		resolve: (ctx) =>
			['age_selection', 'age_selection_mature'].includes(ctx.locationStore.getQueryParam('lptype') ?? ''),
	}),

	disable_weight_loss_boost: defineFeatureFlag({
		description: 'True outside the EU — weight-loss-boost upsell is EU-only.',
		type: 'boolean',
		resolve: (ctx) => !EU_REGION_COUNTRIES_REGEX.test(ctx.mainStore.getCountryCode),
	}),
} satisfies FeatureFlagsMap
